var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs2, _polygon, _defs3, _polygon2, _defs4, _polygon3, _defs5, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoInner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 286.62 53.34",
    style: {
      enableBackground: "new 0 0 286.62 53.34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:#00ACA1;}\r\n\t.st1{clip-path:url(#SVGID_2_);fill:#213B4F;}\r\n\t.st2{clip-path:url(#SVGID_4_);fill:url(#SVGID_5_);}\r\n\t.st3{clip-path:url(#SVGID_7_);fill:url(#SVGID_8_);}\r\n\t.st4{clip-path:url(#SVGID_10_);fill:url(#SVGID_11_);}\r\n\t.st5{clip-path:url(#SVGID_13_);fill:url(#SVGID_14_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 286.62,
    height: 53.34
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.86,33.25c-0.08,0.18-0.13,0.31-0.23,0.31c-0.08,0-0.16-0.05-0.18-0.21c-0.26-1.46-2.08-2.55-4.21-2.55 c-2,0-3.8,0.88-3.8,3.12c0,1.82,2.26,2.24,4.65,2.39c3.64,0.23,5.3,1.2,5.3,3.69c0,3.72-4.32,4.6-7.25,4.6 c-2.08,0-4.19-0.31-6.14-1.04l0.55-2.16c0.08-0.31,0.16-0.49,0.23-0.49c0.1,0,0.13,0.1,0.16,0.23c0.42,2.05,3.56,2.96,5.36,2.96 c2,0,4.5-0.73,4.5-3.12c0-1.98-1.56-2.24-4.6-2.5c-2.31-0.21-5.36-0.94-5.36-3.82c0-3.59,4-4.37,6.84-4.37 c1.51,0,3.43,0.42,4.84,0.99L11.86,33.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.09,30.31c4.45,0,7.72,2.99,7.72,7.15c0,4.16-3.28,7.15-7.72,7.15c-4.42,0-7.7-2.99-7.7-7.15 C15.39,33.31,18.67,30.31,23.09,30.31 M23.09,44.12c3.9,0,4.71-3.59,4.71-6.66c0-3.07-0.81-6.66-4.71-6.66 c-3.87,0-4.68,3.59-4.68,6.66C18.41,40.53,19.21,44.12,23.09,44.12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.74,40.95c0,1.64,0.08,2.63,1.48,3.12c0.1,0.05,0.16,0.1,0.16,0.15c0,0.05-0.13,0.08-0.23,0.08 c-0.13,0-0.81-0.08-2.76-0.08c-1.4,0-2.52,0.08-2.7,0.08c-0.16,0-0.26,0-0.26-0.08c0-0.05,0.05-0.1,0.16-0.15 c1.43-0.6,1.48-1.48,1.48-3.12V28.52c0-1.27-0.23-1.79-0.89-1.92c-0.15-0.03-0.39-0.1-0.39-0.21c0-0.13,0.21-0.16,0.39-0.18 c1.22-0.23,2.32-0.49,3.56-0.83V40.95z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.95,40.92c0,2.16,0.31,2.83,1.43,3.12c0.1,0.03,0.16,0.05,0.16,0.08c0,0.08-0.16,0.1-0.34,0.1H52.1 c-0.39-0.86-0.62-1.77-0.68-2.99h-0.05c-0.86,2.31-2.39,3.38-5.07,3.38c-3.72,0-5.54-1.43-5.54-5.62v-5.25 c0-1.51-0.1-1.82-0.83-2.08c-0.21-0.05-0.39-0.13-0.39-0.21c0-0.08,0.16-0.08,0.39-0.1c1.17-0.16,2.26-0.42,3.51-0.75v8.42 c0,2.39,1.07,4.94,3.82,4.94c2.7,0,4-2.57,4-4.99v-5.23c0-1.59-0.29-1.92-0.75-2.16c-0.24-0.13-0.34-0.16-0.34-0.18 c0-0.08,0.29-0.13,0.42-0.16c1.01-0.15,2.05-0.34,3.35-0.65V40.92z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.89,32.19c-0.16,0-0.26-0.1-0.26-0.23s0.21-0.23,0.52-0.36c1.48-0.52,2.73-1.72,3.69-3.69 c0.08-0.18,0.18-0.26,0.29-0.26c0.13,0,0.13,0.18,0.13,0.36v3.35h2.89l-0.18,0.83h-2.7v7.38c0,3.46,0.83,4.08,1.66,4.37 c0.21,0.08,0.31,0.1,0.31,0.18c0,0.08-0.18,0.1-0.42,0.1h-3.15c-0.73-0.34-1.09-0.91-1.09-1.9V32.19H56.89z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.79,33.38c0-1.3-0.49-1.46-0.91-1.69c-0.16-0.08-0.44-0.08-0.44-0.16c0-0.05,0.29-0.08,0.47-0.1 c1.22-0.24,2.31-0.49,3.56-0.83v10.35c0,1.64,0.16,2.81,1.35,3.04c0.16,0.03,0.26,0.08,0.26,0.23c0,0.08-0.13,0.08-0.36,0.08 c-0.26,0-1.2-0.08-2.6-0.08s-2.34,0.08-2.6,0.08c-0.23,0-0.36,0-0.36-0.08c0-0.16,0.1-0.21,0.26-0.23c1.2-0.23,1.38-1.4,1.38-3.04 V33.38z M66.38,27.38c0-0.83,0.7-1.56,1.53-1.56c0.88,0,1.56,0.73,1.56,1.56c0,0.83-0.68,1.53-1.56,1.53 C67.08,28.91,66.38,28.21,66.38,27.38"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.39,30.31c4.45,0,7.72,2.99,7.72,7.15c0,4.16-3.28,7.15-7.72,7.15c-4.42,0-7.7-2.99-7.7-7.15 C72.7,33.31,75.97,30.31,80.39,30.31 M80.39,44.12c3.9,0,4.71-3.59,4.71-6.66c0-3.07-0.81-6.66-4.71-6.66 c-3.87,0-4.68,3.59-4.68,6.66C75.71,40.53,76.52,44.12,80.39,44.12"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.39,34.34h0.05c0.6-2.21,1.87-4.03,5.3-4.03c2.86,0,5.54,1.48,5.54,5.62v5.02 c-0.05,2.47,0.29,2.83,1.04,3.09c0.18,0.05,0.34,0.13,0.34,0.18c0,0.08-0.13,0.08-0.39,0.08c-0.23,0-0.91-0.08-2.34-0.08 c-1.4,0-2.34,0.08-2.68,0.08c-0.16,0-0.29,0-0.29-0.08c0-0.05,0.05-0.13,0.23-0.16c0.94-0.1,1.4-0.81,1.4-3.12V35.9 c0-2.39-1.07-4.94-3.82-4.94c-3.09,0-4.11,3.17-4.11,6.81v3.17c0,1.64,0.08,2.86,1.25,3.07c0.18,0.03,0.29,0.08,0.29,0.16 c0,0.1-0.08,0.13-0.23,0.13c-0.18,0-1.25-0.08-2.65-0.08s-2.6,0.08-2.78,0.08c-0.15,0-0.23-0.03-0.23-0.13 c0-0.08,0.1-0.13,0.29-0.16c1.3-0.21,1.4-1.43,1.4-3.07V34.5c0-1.56-0.18-2.44-0.91-2.76c-0.29-0.13-0.47-0.21-0.47-0.26 c0-0.08,0.18-0.08,0.5-0.13c1.25-0.23,2.31-0.42,3.28-0.75V34.34z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.73,41.96c0,0.86,0.13,1.64,0.94,2c0.16,0.08,0.26,0.08,0.26,0.16c0,0.08-0.16,0.1-0.34,0.1h-2.81 c-0.36-0.83-0.57-1.74-0.62-2.65h-0.05c-1.01,2.11-2.52,3.04-4.81,3.04c-2.7,0-5.49-1.25-5.49-4.34c0-3.95,6.03-4.34,8.76-4.34 h1.48v-0.86c0-2.5-1.17-4.26-3.8-4.26c-2.39,0-3.8,0.7-4.73,2.99c-0.1,0.23-0.16,0.44-0.21,0.44c-0.05,0-0.08-0.13-0.13-0.29 l-0.68-2.34c2.13-1.12,3.82-1.3,6.14-1.3c2.96,0,6.08,1.07,6.08,4.34V41.96z M117.05,36.42h-1.53c-2.81,0-5.69,0.83-5.69,4.26 c0,1.9,1.38,3.28,3.22,3.28c3.07,0,4-3.22,4-5.72V36.42z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.57,33.95h0.05c1.01-2.16,2.83-3.74,5.28-3.64l-1.09,2.68c-0.44-0.34-1.07-0.42-1.61-0.42 c-1.48,0-2.47,1.9-2.47,3.59v4.78c0,1.64,0.13,2.86,1.48,3.12c0.18,0.05,0.26,0.1,0.26,0.16c0,0.08-0.08,0.08-0.21,0.08 c-0.18,0-1.46-0.08-2.89-0.08c-1.4,0-2.63,0.08-2.78,0.08c-0.13,0-0.23-0.03-0.23-0.08c0-0.05,0.1-0.1,0.29-0.13 c1.22-0.44,1.4-0.96,1.4-3.15v-6.22c0-1.79-0.1-2.73-1.01-2.94c-0.26-0.08-0.39-0.16-0.39-0.21c0.03-0.1,0.36-0.08,0.55-0.13 c1.2-0.21,2.29-0.47,3.38-0.86V33.95z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.79,43.99c-0.75,1.51-1.82,3.41-3.15,4.37c-1.04,0.78-2.29,1.07-4,1.01l0.81-2.21 c0.1-0.31,0.16-0.6,0.23-0.6c0.05,0,0.08,0.05,0.08,0.1c0.29,0.73,1.2,0.94,1.9,0.94c1.69,0,2.57-1.69,2.57-3.17 c0-1.04-0.83-2.73-1.38-3.85l-3.87-7.78c-0.42-0.78-0.81-1.51-1.69-1.95c-0.08-0.05-0.13-0.08-0.13-0.16c0-0.1,0.16-0.1,0.36-0.1 c0.83,0,1.14,0.1,2.52,0.1c1.27,0,1.59-0.1,2.42-0.1c0.23,0,0.36,0,0.36,0.1c0,0.08-0.05,0.1-0.16,0.13 c-0.47,0.18-0.99,0.23-0.99,1.14c0,0.62,0.55,1.85,0.81,2.29l3.85,7.15l2.31-4.45c0.86-1.72,1.61-3.43,1.61-4.42 c0-0.94-0.47-1.38-1.17-1.59c-0.16-0.05-0.23-0.1-0.23-0.26c0-0.1,0.13-0.1,0.31-0.1c0.29,0,0.94,0.1,2.05,0.1 c1.07,0,1.79-0.1,2-0.1c0.21,0,0.31,0,0.31,0.1c0,0.08-0.05,0.13-0.13,0.18c-0.88,0.6-2.39,3.04-2.91,4.03L140.79,43.99z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.12,28.52c0-1.4-0.29-1.9-0.86-1.98c-0.18-0.02-0.42-0.05-0.42-0.13c0-0.1,0.21-0.13,0.44-0.18 c1.17-0.26,2.26-0.52,3.51-0.86v8.53h0.05c0.73-2.6,2.5-3.59,5.02-3.59c2.86,0,5.54,1.48,5.54,5.62v5.02 c-0.05,2.47,0.29,2.83,1.04,3.09c0.18,0.05,0.34,0.13,0.34,0.18c0,0.08-0.13,0.08-0.39,0.08c-0.23,0-0.91-0.08-2.34-0.08 c-1.4,0-2.34,0.08-2.68,0.08c-0.16,0-0.29,0-0.29-0.08c0-0.05,0.05-0.13,0.23-0.15c0.94-0.1,1.4-0.81,1.4-3.12V35.9 c0-2.39-1.07-4.94-3.82-4.94c-3.09,0-4.11,3.17-4.11,6.81v3.17c0,1.64,0.08,2.86,1.25,3.07c0.18,0.03,0.29,0.08,0.29,0.16 c0,0.1-0.08,0.13-0.23,0.13c-0.18,0-1.25-0.08-2.65-0.08c-1.4,0-2.6,0.08-2.78,0.08c-0.16,0-0.23-0.03-0.23-0.13 c0-0.08,0.1-0.13,0.29-0.16c1.3-0.21,1.4-1.43,1.4-3.07V28.52z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.99,35.64c-0.05,0.6-0.08,1.15-0.08,1.69c0,4.84,2.5,6.63,5.02,6.63c2.99,0,5.2-2.05,6.09-5.1h0.55 c-0.83,3.59-3.43,5.75-6.97,5.75c-4.42,0-7.7-2.99-7.7-7.15c0-4.16,3.28-7.15,7.7-7.15c2.83,0,6.27,1.72,6.63,5.33H177.99z  M185.95,35.15c0-2.55-1.22-4.34-3.93-4.34c-2.37,0-3.64,2.11-3.93,4.34H185.95z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.23,41.96c0,0.86,0.13,1.64,0.94,2c0.16,0.08,0.26,0.08,0.26,0.16c0,0.08-0.16,0.1-0.34,0.1h-2.81 c-0.36-0.83-0.57-1.74-0.62-2.65h-0.05c-1.01,2.11-2.52,3.04-4.81,3.04c-2.7,0-5.49-1.25-5.49-4.34c0-3.95,6.03-4.34,8.76-4.34 h1.48v-0.86c0-2.5-1.17-4.26-3.8-4.26c-2.39,0-3.8,0.7-4.73,2.99c-0.1,0.23-0.16,0.44-0.21,0.44c-0.05,0-0.08-0.13-0.13-0.29 l-0.68-2.34c2.13-1.12,3.82-1.3,6.14-1.3c2.96,0,6.08,1.07,6.08,4.34V41.96z M201.55,36.42h-1.53c-2.81,0-5.69,0.83-5.69,4.26 c0,1.9,1.38,3.28,3.22,3.28c3.07,0,4-3.22,4-5.72V36.42z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.27,40.95c0,1.64,0.08,2.63,1.48,3.12c0.1,0.05,0.16,0.1,0.16,0.15c0,0.05-0.13,0.08-0.23,0.08 c-0.13,0-0.81-0.08-2.76-0.08c-1.4,0-2.52,0.08-2.7,0.08c-0.16,0-0.26,0-0.26-0.08c0-0.05,0.05-0.1,0.16-0.15 c1.43-0.6,1.48-1.48,1.48-3.12V28.52c0-1.27-0.23-1.79-0.88-1.92c-0.15-0.03-0.39-0.1-0.39-0.21c0-0.13,0.21-0.16,0.39-0.18 c1.22-0.23,2.32-0.49,3.56-0.83V40.95z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.57,32.19c-0.16,0-0.26-0.1-0.26-0.23s0.21-0.23,0.52-0.36c1.48-0.52,2.73-1.72,3.69-3.69 c0.08-0.18,0.18-0.26,0.29-0.26c0.13,0,0.13,0.18,0.13,0.36v3.35h2.89l-0.18,0.83h-2.7v7.38c0,3.46,0.83,4.08,1.66,4.37 c0.21,0.08,0.31,0.1,0.31,0.18c0,0.08-0.18,0.1-0.42,0.1h-3.15c-0.73-0.34-1.09-0.91-1.09-1.9V32.19H214.57z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.12,28.52c0-1.4-0.29-1.9-0.86-1.98c-0.18-0.02-0.42-0.05-0.42-0.13c0-0.1,0.21-0.13,0.44-0.18 c1.17-0.26,2.26-0.52,3.51-0.86v8.53h0.05c0.73-2.6,2.5-3.59,5.02-3.59c2.86,0,5.54,1.48,5.54,5.62v5.02 c-0.05,2.47,0.29,2.83,1.04,3.09c0.18,0.05,0.34,0.13,0.34,0.18c0,0.08-0.13,0.08-0.39,0.08c-0.23,0-0.91-0.08-2.34-0.08 c-1.4,0-2.34,0.08-2.68,0.08c-0.15,0-0.29,0-0.29-0.08c0-0.05,0.05-0.13,0.23-0.15c0.94-0.1,1.4-0.81,1.4-3.12V35.9 c0-2.39-1.07-4.94-3.82-4.94c-3.09,0-4.11,3.17-4.11,6.81v3.17c0,1.64,0.08,2.86,1.25,3.07c0.18,0.03,0.29,0.08,0.29,0.16 c0,0.1-0.08,0.13-0.23,0.13c-0.18,0-1.25-0.08-2.65-0.08c-1.4,0-2.6,0.08-2.78,0.08c-0.16,0-0.23-0.03-0.23-0.13 c0-0.08,0.1-0.13,0.29-0.16c1.3-0.21,1.4-1.43,1.4-3.07V28.52z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M272.34,0l-13.12,16.48c0,0-4.63,5.49-1.03,6.3c3.6,0.81,2.33,0.44,5.16,0.11 c2.83-0.34,5.52-0.85,5.52-0.85l4.59-5.73c0,0,4.49-5.12,2.35-9.96C273.67,1.51,272.34,0,272.34,0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 53.2862,
    x2: 1,
    y2: 53.2862,
    gradientTransform: "matrix(-21.3687 10.6674 10.6674 21.3687 -292.285 -1131.7905)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009192"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00910794,
    style: {
      stopColor: "#009192"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0982,
    style: {
      stopColor: "#009997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2248,
    style: {
      stopColor: "#00A19B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    style: {
      stopColor: "#00A69E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5744,
    style: {
      stopColor: "#00AAA1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00ACA1"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "287.37,18.88 259.25,32.92 245.17,4.7 273.29,-9.33  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_6_",
    d: "M280.09,30.46c-2.84,0.33-5.52,0.85-5.52,0.85l-4.59,5.73c0,0-4.49,5.12-2.35,9.96 c2.14,4.84,3.47,6.35,3.47,6.35l13.12-16.47c0,0,4.63-5.49,1.03-6.3c-1.61-0.36-2.24-0.49-2.7-0.49 C281.97,30.07,281.66,30.27,280.09,30.46"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_6_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 53.4605,
    x2: 1,
    y2: 53.4605,
    gradientTransform: "matrix(-14.6287 19.1502 19.1502 14.6287 -745.2717 -742.1088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005B64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00787229,
    style: {
      stopColor: "#005B64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    style: {
      stopColor: "#007478"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    style: {
      stopColor: "#008A88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    style: {
      stopColor: "#009B95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5367,
    style: {
      stopColor: "#00A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6525,
    style: {
      stopColor: "#00ACA1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7587,
    style: {
      stopColor: "#00B0A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8827,
    style: {
      stopColor: "#00B3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4AC"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "300.07,38.65 280.24,64.61 254.27,44.76 274.1,18.81  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M266.38,27.03c-2.84,0.34-5.52,0.85-5.52,0.85l-4.59,5.73c0,0-4.49,5.12-2.35,9.96 c2.14,4.83,3.47,6.35,3.47,6.35l13.12-16.48c0,0,4.63-5.49,1.03-6.3c-1.6-0.36-2.24-0.49-2.71-0.49 C268.26,26.65,267.95,26.84,266.38,27.03"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 53.4605,
    x2: 1,
    y2: 53.4605,
    gradientTransform: "matrix(-14.6287 19.1502 19.1502 14.6287 -751.0395 -755.933)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000015"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3166,
    style: {
      stopColor: "#000015"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3444,
    style: {
      stopColor: "#00051B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4842,
    style: {
      stopColor: "#001F35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#00304B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    style: {
      stopColor: "#003B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8841,
    style: {
      stopColor: "#004266"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00456B"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "286.36,35.22 266.53,61.18 240.56,41.34 260.39,15.38  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_12_",
    d: "M257.7,28.25c2.92,5.84,6.82,5.21,7.83,5.2c1.01-0.01,11.35-1.74,16.04-2.4c4.69-0.67,4.67,2.51,4.67,2.51 c0.96-1.96,0.15-7.2-2.67-10.95s-8.21-2.04-14.58-0.91c-6.37,1.13-7.39,1.52-10.05,1.03c-2.66-0.49-1.99-2.42-1.99-2.42 S255.24,23.33,257.7,28.25"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 53.3605,
    x2: 1,
    y2: 53.3605,
    gradientTransform: "matrix(23.1719 -11.5675 -11.5675 -23.1719 876.9318 1268.6971)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005B64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00787229,
    style: {
      stopColor: "#005B64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    style: {
      stopColor: "#007478"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    style: {
      stopColor: "#008A88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    style: {
      stopColor: "#009B95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5367,
    style: {
      stopColor: "#00A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6525,
    style: {
      stopColor: "#00ACA1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7587,
    style: {
      stopColor: "#00B0A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8827,
    style: {
      stopColor: "#00B3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4AC"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "249.15,21.9 280.82,6.09 293.28,31.06 261.61,46.87  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInner);
export default __webpack_public_path__ + "static/media/logo-inner.7e7e5bfccaf9a24b3ce5bb4adafb0b30.svg";
export { ForwardRef as ReactComponent };